module.exports = __webpack_public_path__ + "static/media/ehs-primary-background.416633c1.png";